export const META_TYPE = 'cmcUsage';
export const META_VER = 'v1';

export const CMD_CMCUSAGE_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
